import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { PayoutsApiAdapter } from '../adapters';
import { CreateAdvanceItemsRequest } from '../models';

export const useCreateAdvanceItems = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const payoutsAdapter = new PayoutsApiAdapter(httpClient);

  const mutation = useMutation({
    mutationFn: (data: CreateAdvanceItemsRequest) =>
      payoutsAdapter.createAdvanceItems(data),
    onSuccess: () => {
      // Invalidar cache de payouts para refrescar la lista
      queryClient.invalidateQueries({ queryKey: ['cod-payouts'] });
    },
  });

  return {
    createAdvanceItems: mutation.mutate,
    createAdvanceItemsAsync: mutation.mutateAsync,
    isCreating: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};

